import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoLn: CultureInfo = {
  name: 'ln',
  displayName: 'lingála',
  iso3LanguageCode: 'lin',
  iso2LanguageCode: 'ln',
  ietfLanguageTag: 'ln',
  parent: null
};
